<template lang="pug">
v-container.pa-0
  v-layout
    v-flex.custom-inputs(xs12)
      v-layout(row, wrap)
        v-flex(xs12)
          div.v-menu--inline
            slot(name='extra-options')
          v-menu.py-2.px-3(v-if="teamMembersInfo.length > 1" offset-y)
            v-toolbar-title.menu(slot='activator')
              span {{ selectedMember && selectedMember.text }}
              v-icon(color='primary' right) arrow_drop_down
            v-list
              v-list-tile(
                v-for='member in members'
                @click='onMemberchange(member)'
              )
                v-list-tile-title {{ member.text }}
          v-menu.py-2.px-3(offset-y)
            v-toolbar-title.menu(slot='activator')
              span {{ selectedDate.text }}
              v-icon(color='primary' right) arrow_drop_down
            v-list
              v-list-tile(v-for='date in dates' :key='date.value' @click='onDateChange(date)')
                v-list-tile-title {{ date.text }}
          v-menu.py-2.px-3(
            v-if="!hideTypeSelector"
            v-model='activitiesDropdown'
            offset-y 
            content-class="dropdown-box py-3"
            :close-on-content-click= "false")
            v-toolbar-title.menu(slot='activator')
              span {{ getTypeFilterName() }}
              v-icon(color='primary' right) arrow_drop_down
            v-flex(xs12)
              v-flex.dropdown-title
                span.title-style CONTACT ACTIVITY FILTER
                v-text-field(
                  v-model='searchText'
                  prepend-icon="search"
                  placeholder="Search available activity types")
              v-list.overflow-scroll
                v-list-tile(v-for='type in filterTypes()' @click='onTypeChange(type)')
                  v-list-tile-action
                    v-checkbox(
                      :input-value="selectedIDsIncludesType(type)"
                      color="primary"
                      light
                      hide-details)
                  v-list-tile-content
                    v-list-tile-title {{ type.text }}
              v-flex.centered.xs12
                v-btn(@click="onCancelTypesChanges" flat) Cancel
                v-btn.primary(@click="onApplyTypesChanges") Apply
    // Temporarily hidden
    v-flex.mt-2(v-if="false" xs6)
      v-layout(row justify-start)
        v-layout.options.px-2(align-center column)
          v-icon.icon.email email
          span {{ mailsCount }}
          span Emails
        v-layout.options.px-2(align-center column)
          v-icon.icon.texts stay_primary_portrait
          span {{ textsCount }}
          span Texts
        v-layout.options.px-2(align-center column)
          v-icon.icon.call phone
          span {{ callsCount }}
          span Calls
        v-layout.options.px-2(align-center column)
          v-icon.icon.comment comment
          span {{ commentsCount }}
          span Comments
        v-layout.options.px-2(align-center column)
          v-icon.icon.visit home
          span {{ visitsCount }}
          span Visits
        v-layout.options.px-2(align-center column)
          v-icon.icon.pin push_pin
          span {{ pinnedActivities }}
          span Pins
        v-layout(column align-center)
          v-menu.more--menu(open-on-hover offset-y max-height='300' left)
            v-btn.options(icon, slot='activator')
              v-icon more_vert
            v-list
              v-list-tile(v-for='event in moreEvents')
                v-list-tile-title
                  span {{ event.text }} ({{ event.count }})
          span.options More
</template>

<script>
import { eventTypes, dateFilters } from '@/Core/config/events';

import { countedEventTypes } from '../../config/counted-event-types';

import { createNamespacedHelpers, mapGetters, mapActions } from 'vuex';

const { mapGetters: mapTeamMembersGetters } = createNamespacedHelpers('teamMembers');

const allEvents = eventTypes.reduce((acc, { types }) => [...acc, ...types], []); //concat all event types

const moreTypes = allEvents.reduce((acc, type) => {
  const list = Object.keys(countedEventTypes).map(key => countedEventTypes[key].text);
  if(!list.includes(type)) return [...acc, type];
  return acc;
}, []); //remove counted event types as computed property

export default {
  async created() {
    await this.getIntegrationStatus();
    this.selectedMember = this.members[0];
    this.selectedTypesIDs = JSON.parse(JSON.stringify(this.allEventTypeIDs));
    this.currentTypesIDs = JSON.parse(JSON.stringify(this.allEventTypeIDs));
  },

  computed: {
    ...mapTeamMembersGetters(['teamMembersInfo']),
    ...mapGetters('qualify', ['isIntegrationConnected']),
    members() {
      const teamMembers = this.teamMembersInfo.reduce((team, member) => {
        if (!team.some(m => m.value === member.value)) {
          team.push(member);
        }
        return team;
      }, []);

      return [
        {
          text: 'All Users',
          value: null,
        },
        ...teamMembers,
      ];
    },
    pinnedActivities() {
      return this.events.filter(activity => activity.pinned).length;
    },
    commentsCount() {
      return this.events.filter(
        activity => activity.type === countedEventTypes.contact_comments.text,
      ).length;
    },
    mailsCount() {
      return this.events.filter(
        activity =>
          activity.type === countedEventTypes.email_sent.text ||
          activity.type === countedEventTypes.email_received.text ||
          activity.type === countedEventTypes.email_3rd_party.text,
      ).length;
    },
    textsCount() {
      return this.events.filter(
        activity =>
          activity.type === countedEventTypes.text_sent.text ||
          activity.type === countedEventTypes.text_received.text,
      ).length;
    },
    callsCount() {
      return this.events.filter(
        activity =>
          activity.type === countedEventTypes.inbound_call.text ||
          activity.type === countedEventTypes.outbound_call.text,
      ).length;
    },
    visitsCount() {
      return this.events.filter(activity => activity.type === countedEventTypes.visit.text).length;
    },
    moreEvents() {
      const listEventsTypes = moreTypes.map(type => ({
          text: type,
          count: this.events.filter(activity => activity.type === type).length,
      }));

      const otherType = this.events.reduce(
        (acc, event) => {
          if (allEvents.indexOf(event.type) == -1) {
            return { text: acc.text, count: acc.count + 1 };
          }
          return acc;
        },
        { text: 'Other events', count: 0 },
      );

      return listEventsTypes.concat(otherType);
    },
    allEventTypeIDs() {
      return eventTypes.map(type => type.id)
    }
  },
  data() {
    return {
      allTypeOptionID: eventTypes[0].id,
      activitiesDropdown: false,
      searchText: "",
      selectedTypes: JSON.parse(JSON.stringify(eventTypes)),
      selectedTypesIDs: [],
      currentTypesIDs: [],
      selectedDate: dateFilters[0],
      types: eventTypes,
      dates: dateFilters,
      selectedMember: null,
    };
  },
  props: {
    events: {
      default: [],
    },
    hideTypeSelector: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    ...mapActions('qualify', ['getIntegrationStatus']),
    selectedIDsIncludesType(type) {
      return this.selectedTypesIDs.includes(type.id);
    },
    onTypeChange(type) {
      if (type.id === this.allTypeOptionID) {
        if (this.selectedTypesIDs.includes(type.id)) {
          this.selectedTypesIDs = [];
        }
        else {
          this.selectedTypesIDs = JSON.parse(JSON.stringify(this.allEventTypeIDs));
        }
      }
      else {
        if (this.selectedTypesIDs.includes(type.id)) {
          this.selectedTypesIDs.splice(this.selectedTypesIDs.indexOf(type.id), 1);
          if (this.selectedTypesIDs.includes(this.allTypeOptionID)) {
            this.selectedTypesIDs.splice(this.selectedTypesIDs.indexOf(this.allTypeOptionID), 1);
          }
        }
        else {
          this.selectedTypesIDs.push(type.id);
        }
      }
    },
    onApplyTypesChanges() {
      this.currentTypesIDs = JSON.parse(JSON.stringify(this.selectedTypesIDs));
      this.selectedTypes = this.types.filter((type) => this.currentTypesIDs.includes(type.id));
      this.activitiesDropdown = false;
      this.searchText = "";
      this.$emit('type-updated', this.selectedTypes);
    },
    onCancelTypesChanges() {
      this.selectedTypesIDs = JSON.parse(JSON.stringify(this.currentTypesIDs));
      this.searchText = "";
      this.activitiesDropdown = false;
    },
    getTypeFilterName() {
      if (this.currentTypesIDs.includes(this.allTypeOptionID)) {
        return eventTypes[0].text;
      }
      return `Filters Selected (${this.currentTypesIDs.length}/${this.types.length - 1})`;
    },
    filterTypes() {
      var filteredTypes = this.types;
      if (!this.isIntegrationConnected) {
        filteredTypes = this.types.filter(type => type && !type.text.toLowerCase().includes('qualify'));
      }
      return filteredTypes.filter(type => type && type.text.toLowerCase().includes(this.searchText.toLowerCase()));
    },
    onMemberchange(member) {
      this.selectedMember = member;
      this.$emit('member-updated', member);
    },

    onDateChange(date) {
      this.selectedDate = date;
      this.$emit('date-updated', date);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../Core/assets/scss/main.scss";
.options {
  color: #20779c;
  font-size: 12px;
}
.actions {
  align-self: center;
}
.centered {
  display: flex;
  justify-content: center;
}
.dropdown-title {
  flex-direction: column;
  padding-left: 16px;
  padding-right: 16px;
}
.icon {
  font-size: 18px;
  border-radius: 50%;
  color: var(--v-background-lighten5) !important;
  height: 35px;
  width: 35px;
  &.email {
    background-color: $mail-icon;
  }
  &.texts {
    background-color: $text-icon;
  }
  &.call {
    background-color: $call-icon;
  }
  &.comment {
    background-color: $comment-icon;
  }
  &.visit {
    background-color: $visit-icon;
  }
  &.pin {
    background-color: $pin-icon;
  }
}
.menu {
  color: #20779c;
  font-size: 14px;
  font-weight: bold;
}
.search {
  border: 2px solid #20779c;
  border-radius: 5px;
  width: 200px;
  height: 29px;
}
</style>

<style lang="scss">
.custom-inputs .v-text-field .v-input__control .v-input__slot {
  min-height: auto;
  display: flex;
  align-items: center;
}

.custom-inputs .theme--light .v-label,
.custom-inputs .theme--light .v-icon {
  color: #20779c;
}

.overflow-scroll {
  height: 500px;
  width: 300px;
  overflow-y: scroll;
}

.title-style {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
}

.dropdown-box {
  background-color: white;
  border-radius: 6px;
}

.more--menu.v-menu.v-menu--inline {
  .v-menu__activator {
    height: 35px !important;
  }
}
</style>